export const FETCH_CAR_CATEGORIES_START = "FETCH_CAR_CATEGORIES_START";
export const FETCH_CAR_CATEGORIES_SUCCESS = "FETCH_CAR_CATEGORIES_SUCCESS";
export const FETCH_CAR_CATEGORIES_FAIL = "FETCH_CAR_CATEGORIES_FAIL";

export const UPDATE_CAR_CATEGORY_START = "UPDATE_CAR_CATEGORY_START";
export const UPDATE_CAR_CATEGORY_SUCCESS = "UPDATE_CAR_CATEGORY_SUCCESS";
export const UPDATE_CAR_CATEGORY_FAIL = "UPDATE_CAR_CATEGORY_FAIL";

export const CHECK_CAR_CATEGORY_START = "CHECK_CAR_CATEGORY_START";
export const CHECK_CAR_CATEGORY_SUCCESS = "CHECK_CAR_CATEGORY_SUCCESS";
export const CHECK_CAR_CATEGORY_FAIL = "CHECK_CAR_CATEGORY_FAIL";

export const SET_CAR_CATEGORY_SEARCH_INPUT = "SET_CAR_CATEGORY_SEARCH_INPUT";
